import React, { ChangeEventHandler, FormEventHandler, useState } from 'react';
import { Coupon } from '@/types';
import axios from 'axios';

interface CouponInputProps {
  endpoint: string;
  onChange: (coupon: Coupon | undefined) => void;
}

export function CouponInput({ endpoint, onChange }: CouponInputProps) {
  const [couponCode, setCouponCode] = useState('');
  const [couponMessage, setCouponMessage] = useState<{ type: string; message: string }>();

  const change: ChangeEventHandler<HTMLInputElement> = (event) => {
    setCouponCode(event.target.value);
  };

  const submit: FormEventHandler = async (event) => {
    event.preventDefault();

    try {
      const response = await axios.post(
        endpoint,
        { code: couponCode },
        {
          maxRedirects: 0,
          validateStatus: (status) => status >= 200 && status < 300,
        }
      );

      // Check if we got valid coupon data back
      if (!response.data?.coupon) {
        throw new Error('Invalid response format');
      }

      setCouponMessage({ type: 'success', message: 'Coupon applied' });
      onChange(response.data.coupon);
    } catch (error) {
      if (
        axios.isAxiosError(error) &&
        error.response?.status &&
        error.response.status >= 300 &&
        error.response.status < 400
      ) {
        // Handle redirects as errors
        setCouponMessage({ type: 'danger', message: 'Session expired or unauthorized' });
      } else if (error.response?.data?.message) {
        setCouponMessage({ type: 'danger', message: error.response?.data?.message });
      } else {
        setCouponMessage({ type: 'danger', message: 'Invalid coupon' });
      }
      onChange(undefined);
    }
  };

  return (
    <form className="row row-cols-sm-auto g-3 align-items-center" onSubmit={submit}>
      <div className="col-12">
        <input type="text" className="form-control" value={couponCode} onChange={change} placeholder="CODE" required />
      </div>

      <div className="col-12">
        <button type="submit" className="btn btn-primary">
          Apply
        </button>
      </div>

      <div className="col-12">
        {couponMessage && <div className={`text-${couponMessage.type}`}>{couponMessage.message}</div>}
      </div>
    </form>
  );
}
